import type * as z from 'zod';

export function parseSchema<T extends z.ZodType>(schema: T, data: unknown): z.infer<T> {
  const result = schema.safeParse(data);

  if (!result.success) {
    console.warn({ data, issues: result.error.issues });
    throw result.error;
  }

  return result.data;
}
